export default "__VITE_ASSET__DkVqoS2C__"